import { groupHomeConstants as gh } from 'srcReact/GroupHomePage'
import { profileConstants } from 'srcReact/MyProfile/constant'

const initialState = {
  groupLoading: true,
  futureMixrsLoading: true,
  pastMixrsLoading: true,
  refreshGroup: false,
  refreshPendingActions: false,
  past_mixrs: {
    loaded: false,
    loading: true,
    stats: {
      total: 0,
      next_offset: 0,
      remaining: 0
    },
    mixrs: []
  },
  future_mixrs: {
    loaded: false,
    loading: true,
    stats: {
      total: 0,
      next_offset: 0,
      remaining: 0
    },
    mixrs: [],
    pagination: {
      nextOffset: 0,
      isPagination: false
    }
  },
  info: {
    loaded: false,
    loading: true,
    stats: {
      mixrs: {
        planned: 0,
        finished: 0,
        suggested: 0
      },
      featured_files: {
        pictures: 0,
        documents: 0,
        compressed_files: 0
      }
    },
    staff_members: {
      stats: {
        total: 0,
        next_offset: 0,
        remaining: 0
      },
      users: []
    }
  },
  pending_members: {
    stats: {
      total: 0,
      next_offset: 0,
      remaining: 0
    },
    users: []
  },
  suggested_mixrs: {
    stats: {
      total: 0,
      next_offset: 0,
      remaining: 0
    },
    mixrs: []
  },
  group: {
    id: '',
    loaded: false,
    loading: true,
    error: false,
    name: '',
    description: '',
    gmt_creation_date: '',
    members_number: 0,
    automatic_approval_to_join: 0,
    privacy_setting: 'public',
    is_general: 0,
    interests: [],
    workplace: {
      id: '',
      name: '',
      color: '',
      initials: ''
    },
    logged_user: {
      group_attending: 'none',
      group_role: 'none',
      can_plan_mixr: 0,
      can_suggest_mixr: 0
    },
    featured_files: { pictures: [], documents: [] },
    organizer: {
      user_id: '',
      display_name: '',
      picture_url: ''
    },
    picture: {
      path: ''
    }
  },
  stats: {
    mixrs: {
      planned: 0,
      finished: 0,
      suggested: 0
    },
    featured_files: {
      pictures: 0,
      documents: 0,
      compressed_files: 0
    }
  },
  groupOrganizer: null,
  message_draft: null,
  moderation_info: {
    flagged_posts: 0,
    is_suspended: false,
    moderation_id: 0,
    mixrs: {
      suspended_mixrs: []
    }
  },

  // Done by Priyanka
  membersLoading: false,
  users: [],
  usersStat: null,
  staff: [],
  staffStat: null,
  activeMembers: [],
  activeMembersStats: null,
  searchMember: '',
  searchedMemberError: null,
  pictures: [],
  documents: [],
  deleteFileLoading: false,
  loadingFeeds: false,
  feeds: [],
  feedsStats: null,
  newsFeedId: 0,
  loadingSendMessage: false,
  isMessagePosted: false,
  reactionProcessing: false,
  reactionToProcess: null,
  deleteMessageLoading: false,
  isMessageDeleted: false,
  loadingEditMessage: false,
  isMessageEdited: false,
  usersInFeed: [],
  originMessageId: 0,
  loadingMedias: false,
  userAfterChangedRole: null,
  userRemoved: false,
  joinGroupLoading: false,
  joinGroupSuccess: false,
  memberRole: {
    userId: 0,
    type: '', //add/remove
    role: '',
    success: false
  },
  usersToInvite: {
    list: [],
    loading: false,
    error: null,
    stats: null
  },
  widgets: null
}

export function groupHome(state = initialState, action) {
  const { response } = action

  switch (action.type) {
    case gh.SET_GROUP_ROLE: {
      return {
        ...state,
        group: {
          ...state.group,
          logged_user: {
            ...state.group.logged_user,
            group_role: action.joinedGroup.user_group_role,
            group_attending: action.joinedGroup.user_attending_status
          }
        }
      }
    }
    case gh.GET_GROUPHOME_GROUP_INFO_REQUEST:
      return {
        ...state,
        group: {
          ...state.group,
          loading: true,
          loaded: false,
          error: false
        }
      }
    case gh.GET_GROUPHOME_GROUP_INFO_SUCCESS:
      const { staff_members, active_members, organizer, widgets, future_mixrs, past_mixrs } = action.data
      return {
        ...state,
        group: {
          ...state.group,
          ...action.data.group,
          loaded: true,
          loading: false
        },
        stats: {
          ...state.stats,
          ...action.data.stats
        },
        staff: staff_members && staff_members.users,
        staffStat: staff_members && staff_members.stats,
        activeMembers: active_members && active_members.users,
        activeMembersStats: active_members && active_members.stats,
        groupOrganizer: organizer,
        moderation_info: {
          ...state.moderation_info,
          ...action.data.moderation_info
        },
        groupLoading: true,
        widgets: widgets,
        future_mixrs: future_mixrs
          ? {
              ...state.future_mixrs,
              ...future_mixrs
            }
          : { ...state.future_mixrs },
        past_mixrs: past_mixrs
          ? {
              ...state.past_mixrs,
              ...past_mixrs
            }
          : { ...state.past_mixrs }
      }
    case gh.GET_GROUPHOME_GROUP_INFO_FAILURE:
      return {
        ...state,
        group: {
          ...state.group,
          loading: false,
          error: true
        }
      }
    case gh.RESET_GROUPHOME_GROUP_INFO:
      return {
        ...state,
        group: {
          ...state.group,
          error: false
        }
      }
    case gh.GET_GROUPHOME_MIXR_FUTURE_LIST_REQUEST:
    case gh.GET_GROUPHOME_MIXR_FUTURE_LIST_PAGINATION_REQUEST:
      return {
        ...state,
        future_mixrs: {
          ...state.future_mixrs,
          loading: true,
          loaded: false
        }
      }
    case gh.GET_GROUPHOME_MIXR_FUTURE_LIST_SUCCESS:
      return {
        ...state,
        future_mixrs: {
          ...state.future_mixrs,
          ...action.data.future_mixrs,
          loaded: true,
          loading: false
        },
        futureMixrsLoading: true
      }
    case gh.GET_GROUPHOME_MIXR_FUTURE_LIST_PAGINATION_SUCCESS:
      //below code is changed in order to first load updated mixrs and then existing mixrs
      const futureMixrsIds = new Set(action.data.future_mixrs.mixrs.map((m) => m.id))
      return {
        ...state,
        future_mixrs: {
          ...state.future_mixrs,
          ...action.data.future_mixrs,
          mixrs: [
            ...state.future_mixrs.mixrs.filter((m) => !futureMixrsIds.has(m.id)),
            ...action.data.future_mixrs.mixrs //keep updated mixrs first to see latest changes e.g. logged_user
          ].sort((a, b) => new Date(a.utc_start_at) - new Date(b.utc_start_at)),
          loaded: true,
          loading: false
        },
        futureMixrsLoading: true
      }
    case gh.GET_GROUPHOME_MIXR_PAST_LIST_REQUEST:
    case gh.GET_GROUPHOME_MIXR_PAST_LIST_PAGINATION_REQUEST:
      return {
        ...state,
        past_mixrs: {
          ...state.past_mixrs,
          loading: true,
          loaded: false
        }
      }
    case gh.GET_GROUPHOME_MIXR_PAST_LIST_SUCCESS:
      return {
        ...state,
        past_mixrs: {
          ...state.past_mixrs,
          ...action.data.past_mixrs,
          loaded: true,
          loading: false
        },
        pastMixrsLoading: true
      }
    case gh.GET_GROUPHOME_MIXR_PAST_LIST_PAGINATION_SUCCESS:
      const pastMixrsIds = new Set(action.data.past_mixrs.mixrs.map((m) => m.id))
      return {
        ...state,
        past_mixrs: {
          ...state.past_mixrs,
          ...action.data.past_mixrs,
          mixrs: [
            ...state.past_mixrs.mixrs.filter((m) => !pastMixrsIds.has(m.id)),
            ...action.data.past_mixrs.mixrs
          ].sort((a, b) => new Date(b.utc_start_at) - new Date(a.utc_start_at)),
          loaded: true,
          loading: false
        },
        pastMixrsLoading: true
      }
    case gh.GET_GROUPHOME_INFO_REQUEST:
      return {
        ...state,
        info: {
          ...state.info,
          loading: true,
          loaded: false
        }
      }
    case gh.GET_GROUPHOME_INFO_SUCCESS:
      return {
        ...state,
        info: {
          ...state.info,
          stats: {
            ...state.info.stats,
            ...action.data.stats
          },
          staff_members: {
            ...state.info.staff_members,
            ...action.data.staff_members
          },
          loaded: true,
          loading: false
        }
      }
    case gh.GET_GROUPHOME_MEDIA_REQUEST: {
      return {
        ...state,
        loadingMedias: true
      }
    }
    case gh.GET_GROUPHOME_MEDIA_SUCCESS: {
      return {
        ...state,
        loadingMedias: false,
        group: {
          ...state.group,
          ...action.data.group,
          featured_files: action.data.group.featured_files
        }
      }
    }
    case gh.GET_GROUPHOME_PENDING_ACTIONS_SUCCESS:
      return {
        ...state,
        pending_members: {
          ...state.pending_members,
          ...action.data.pending_members
        },
        suggested_mixrs: {
          ...state.suggested_mixrs,
          ...action.data.suggested_mixrs
        }
      }
    case gh.GROUPHOME_PENDING_ACTIONS_SUCCESS:
      return {
        ...state,
        refreshPendingActions: !state.refreshPendingActions
      }
    case gh.REQUEST_TO_JOIN_GROUP_MEMBER_SUCCESS:
      return {
        ...state,
        groupLoading: false,
        refreshGroup: !state.refreshGroup
      }
    case gh.JOIN_GROUP_MEMBER_REQUEST: {
      return {
        ...state,
        joinGroupLoading: true,
        joinGroupSuccess: false
      }
    }
    case gh.JOIN_GROUP_MEMBER_SUCCESS:
      return {
        ...state,
        joinGroupLoading: false,
        joinGroupSuccess: true,
        refreshGroup: !state.refreshGroup
      }
    case gh.JOIN_GROUP_MEMBER_FAILED: {
      return {
        ...state,
        joinGroupLoading: false,
        joinGroupSuccess: false
      }
    }
    case gh.LEAVE_GROUP_MEMBER_SUCCESS:
      return {
        ...state,
        groupLoading: true,
        refreshGroup: !state.refreshGroup
      }
    case gh.DELETE_GROUP_SUCCESS:
      return {
        ...state,
        group: {
          ...state.group,
          loading: false,
          error: true
        }
      }

    case gh.UPDATE_RSVP_DATA: {
      const { rsvpData } = action
      const updatedFutureMixrs = state.future_mixrs.mixrs.map((m) => {
        if (
          m.id === action.mixrId ||
          (m.parent_id === rsvpData.parent_id && rsvpData.recurrence_mixr_attending === 'all')
        ) {
          m.logged_user.mixr_attending = action.rsvpData.attending
          m.logged_user.group_role = action.rsvpData.group_role
          m.logged_user.group_attending = action.rsvpData.group_attending
        }
        return m
      })
      const filteredMixrs = updatedFutureMixrs.filter((m) => m.logged_user.mixr_attending !== 'none')
      return {
        ...state,
        futureMixrsLoading: false,
        future_mixrs: {
          ...state.future_mixrs,
          mixrs: filteredMixrs
        },
        group: {
          ...state.group,
          logged_user: {
            ...state.group.logged_user,
            group_role: action.rsvpData.group_role,
            group_attending: action.rsvpData.group_attending
          }
        }
      }
    }

    case gh.GET_PARTICIPANTS_REQUEST: {
      const { isPagination } = action
      return {
        ...state,
        membersLoading: true,
        searchedMemberError: null,
        searchTerm: '',
        users: isPagination ? [...state.users] : [],
        usersStat: isPagination ? { ...state.usersStat } : {}
      }
    }
    case gh.GET_PARTICIPANTS_SUCCESS: {
      const {
        active_members: { stats, users },
        search,
        isPagination
      } = action.updatedResponse
      let updatedList = [...state.users]
      if (isPagination && users) {
        updatedList = [...state.users, ...users]
      } else if (search.length >= 2 || search.length === 0 || state.users.length === 0) {
        updatedList = users ? [...users] : []
      }
      return {
        ...state,
        users: updatedList,
        usersStat: stats && { ...stats },
        searchedMemberError: null,
        searchTerm: search,
        membersLoading: false,
        activeMembers: updatedList
      }
    }
    case gh.GET_PARTICIPANTS_FAILURE:
      return {
        ...state,
        searchedMemberError: action.error,
        searchTerm: '',
        membersLoading: action.error && action.error.cancelError ? true : false
      }
    case gh.GET_ORGANIZERS_REQUEST: {
      const { isPagination } = action
      return {
        ...state,
        membersLoading: true,
        searchedMemberError: null,
        searchTerm: '',
        staff: isPagination ? [...state.staff] : [],
        staffStat: isPagination ? { ...state.staffStat } : {}
      }
    }
    case gh.GET_ORGANIZERS_SUCCESS: {
      const {
        staff_members: { stats, users },
        search,
        isPagination
      } = action.updatedResponse
      let updatedList = [...state.users]

      if (isPagination && users) {
        updatedList = [...state.users, ...users]
      } else if (search.length >= 2 || search.length === 0 || state.users.length === 0) {
        updatedList = users ? [...users] : []
      }
      return {
        ...state,
        users: updatedList,
        usersStat: stats && { ...stats },
        staff: updatedList,
        staffStat: stats && { ...stats },
        searchedMemberError: null,
        searchTerm: search,
        membersLoading: false
      }
    }
    case gh.GET_ORGANIZERS_FAILURE:
      return {
        ...state,
        searchedMemberError: action.error,
        searchTerm: '',
        membersLoading: action.error && action.error.cancelError ? true : false
      }
    case gh.DELETE_FILE_REQUEST:
      return {
        ...state,
        deleteFileLoading: true
      }
    case gh.DELETE_FILE_SUCCESS:
      if (action.response) {
        const { group } = action.response
        return {
          ...state,
          deleteFileLoading: false,
          group: {
            ...state.group,
            ...group
          }
        }
      } else {
        return { ...state }
      }
    case gh.DELETE_FILE_FAILURE:
      return {
        ...state,
        deleteFileLoading: false
      }
    case gh.SET_ORIGIN_MESSAGE_ID:
      return {
        ...state,
        originMessageId: action.messageId
      }

    case gh.ADD_STAFF_ROLE_REQUEST:
    case gh.REMOVE_STAFF_ROLE_REQUEST: {
      return {
        ...state,
        memberRole: {
          ...state.memberRole,
          success: false
        }
      }
    }
    case gh.ADD_STAFF_ROLE_SUCCESS:
    case gh.REMOVE_STAFF_ROLE_SUCCESS: {
      const { scope, actionType } = action
      const { user_id, user_group_role } = action.response
      const usersToUpdate = [...state.users]
      const usersInFeedToUpdate = [...state.usersInFeed]
      let staffCount = state.group.members.staff
      if (actionType === 'add') {
        staffCount = staffCount + 1
      } else if (actionType === 'remove') {
        staffCount = staffCount - 1
      }
      //for members tab
      for (let i = 0; i < usersToUpdate.length; i++) {
        if (usersToUpdate[i].id == user_id) {
          usersToUpdate[i].role = user_group_role
        }
      }
      //for feeds tab
      if (usersInFeedToUpdate.length > 0) {
        for (let i = 0; i < usersInFeedToUpdate.length; i++) {
          if (usersInFeedToUpdate[i].id == user_id) {
            usersInFeedToUpdate[i].role = user_group_role
          }
        }
      }
      return {
        ...state,

        users:
          scope && scope === 'staff_members'
            ? usersToUpdate.filter((u) => u.role === 'organizer' || u.role === 'co-organizer')
            : [...usersToUpdate],
        usersInFeed: [...usersInFeedToUpdate],
        userAfterChangedRole: { ...action.response },
        group: {
          ...state.group,
          members: {
            ...state.group.members,
            staff: staffCount
          }
        },
        memberRole: {
          userId: user_id,
          role: user_group_role,
          type: actionType,
          success: true
        }
      }
    }
    case gh.ADD_STAFF_ROLE_FAILURE:
    case gh.REMOVE_STAFF_ROLE_FAILURE: {
      return {
        ...state,
        serverErrors: action.error,
        memberRole: {
          ...state.memberRole,
          success: false
        }
      }
    }

    case gh.REMOVE_FROM_GROUP_REQUEST: {
      return {
        ...state,
        userRemoved: false
      }
    }

    case gh.REMOVE_FROM_GROUP_SUCCESS: {
      const { user_id } = action.response

      return {
        ...state,
        users: state.users.filter((u) => u.id != user_id),
        usersInFeed: state.usersInFeed.filter((u) => u.id != user_id),
        userRemoved: true
      }
    }

    case gh.REMOVE_FROM_GROUP_FAILURE: {
      return {
        ...state,
        serverErrors: action.error,
        userRemoved: false
      }
    }

    case gh.ACCEPT_INVITATION_REQUEST:
    case gh.DECLINE_INVITATION_REQUEST: {
      return {
        ...state
      }
    }
    case gh.ACCEPT_INVITATION_SUCCESS: {
      return {
        ...state,
        group: {
          ...state.group,
          logged_user: {
            ...state.group.logged_user,
            group_attending: action.response.user_attending_status,
            group_role: action.response.user_group_role
          }
        },
        refreshGroup: !state.refreshGroup
      }
    }
    case gh.ACCEPT_INVITATION_FAILURE:
    case gh.DECLINE_INVITATION_FAILURE: {
      return {
        ...state
      }
    }

    case gh.DECLINE_INVITATION_SUCCESS: {
      return {
        ...state,
        refreshGroup: !state.refreshGroup
      }
    }

    case gh.GET_USERS_TO_INVITE_REQUEST: {
      const { pagination } = action
      return {
        ...state,
        usersToInvite: {
          ...state.usersToInvite,
          loading: true,
          list: pagination.isPagination ? [...state.usersToInvite.list] : [],
          stats: pagination.isPagination ? { ...state.usersToInvite.stats } : {}
        }
      }
    }
    case gh.GET_USERS_TO_INVITE_SUCCESS: {
      const { pagination, search } = action
      const { suggested_members, group } = action.response
      let updatedList = [...state.usersToInvite.list]
      if (pagination.isPagination && suggested_members.users) {
        updatedList = [...state.usersToInvite.list, ...suggested_members.users]
      } else if (search.length >= 2 || search.length === 0 || state.usersToInvite.list.length === 0) {
        updatedList = suggested_members.users ? [...suggested_members.users] : []
      }

      return {
        ...state,
        group: group,
        usersToInvite: {
          ...state.usersToInvite,
          list: updatedList,
          stats: suggested_members.stats,
          loading: false
        }
      }
    }
    case gh.GET_USERS_TO_INVITE_FAILURE: {
      return {
        ...state,
        usersToInvite: {
          ...state.usersToInvite,
          loading: action.error && action.error.cancelError ? true : false,
          error: action.error
        }
      }
    }
    case gh.GET_WIDGET_SCOPE_REQUEST:
    case gh.GET_WIDGET_SCOPE_FAILURE: {
      return {
        ...state
      }
    }
    case gh.GET_WIDGET_SCOPE_SUCCESS: {
      return {
        ...state,
        widgets: action.response.widgets
      }
    }

    case gh.SET_INITIAL_STATE: {
      return {
        ...initialState
      }
    }
    case profileConstants.ADD_INTEREST_SUCCESS: {
      const updatedInterests = state.group?.interests?.map((interest) => {
        if (action.response.find((x) => x.id === interest.id)) {
          interest.is_common_with_logged_user = 1
        }
        return interest
      })
      return {
        ...state,
        group: {
          ...state.group,
          interests: updatedInterests
        }
      }
    }

    default:
      return state
  }
}
